<template>
  <div>
    <el-form label-position="right" label-width="150px" :model="levelForm">
      <el-form-item label="进阶名称">
        <el-input
            v-model="levelForm.name"
            placeholder="请输出进阶名称"
            maxlength="20"
            clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="选择进度">
        <el-select
            v-model="scheduleId"
            placeholder="请选择"
            @change="changSchedule"
        >
          <el-option
              v-for="item in schedules"
              :label="item.name"
              :key="item.id"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择习题范围">
        <div class="dialogtreeBox">
          　　
          <el-tree
              :data="lessons"
              show-checkbox
              default-expand-all
              ref="questionRange"
              node-key="id"
              :props="defaultProps"
              　　　
          >
          </el-tree>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer flex-center">
        <el-button @click="closeLevelDialog">取 消</el-button>
        <el-button type="primary" @click="addLevel" v-loading="isLoading">确 定</el-button>
      </span>
  </div>
</template>

<script>
export default {
  name: 'advanceLevelAddFormDialog',
  props: {
    isOpen: {type: Boolean},
    subjectId: {type: String},
  },
  data() {
    return {
      scheduleId: null, //进度
      schedules: [],
      lessons: [],  // 课时
      lessonId: null,
      addDialogVisible: false,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      levelForm: {
        name: '',
      },
      isLoading: false,
    };
  },
  methods: {
    //获取可选教学进度列表
    getTeacherSchedules() {
      let params = {'subjectId': this.subjectId};
      this.axios.get('/bank/system/v1.0/teacher/schedules', {params: params}).then((res) => {
        if (res.data.code == 200) {
          this.schedules = res.data.data;
          this.scheduleId = res.data.data[0] ? res.data.data[0].id : '';
          if (this.scheduleId) {
            this.getSchedulesLessons();
          }
        }
      });
    },
    changSchedule() {
      this.getSchedulesLessons();
    },
    // buildTreeData(data) {
    //   data.forEach(item => delete item.children);
    //   let map = {}, val = [];
    //   data.forEach(item => (map[item.id] = item));
    //   data.forEach((item, index) => {
    //     let parent = map[item.parentId];
    //     if (parent) (parent.children || (parent.children = [])).push(item);
    //     else val.push(item);
    //   });
    //   return val;
    // },
    // 获取课时
    getSchedulesLessons(isAutoSelect = false) {
      this.axios.get(`/bank/basedata/v1.0/schedules/${this.scheduleId}/lessons`).then((res) => {
        if (res.data.code == 200) {
          res.data.data.forEach((item, index) => {
            item.label = item.name;
            item.value = item.name + '/' + item.id;
          });
          this.lessons = res.data.data;
        }
      });
    },
    closeLevelDialog() {
      this.$emit('close');
    },
    addLevel() {
      if (!this.levelForm.name) {
        this.$message({
          message: '请先填写进阶名称',
          type: 'warning',
        });
        return;
      }
      let lessonIds = this.$refs.questionRange.getCheckedKeys();
      if (!lessonIds.length) {
        this.$message({
          message: '请选择习题范围',
          type: 'warning',
        });
        return;
      }
      let params = {
        scheduleId: this.scheduleId,
        type: 2,
        name: this.levelForm.name,
        lessonIds: lessonIds,
      };
      this.isLoading = true;
      this.axios.post('/bank/manage/v1.0/promotes', params).then((res) => {
        this.isLoading = false;
        if (res.data.code == 200) {
          this.$message({
            message: '发布成功',
            type: 'success',
          });
          this.$emit('add-success');
        }
      });
    },
  },
  watch: {
    isOpen(newValue, oldValue) {
      if (newValue != oldValue && newValue) {
        this.getTeacherSchedules();
      }
    },
  },
  mounted() {
    if (this.isOpen) {
      this.getTeacherSchedules();
    }
  },
};
</script>

<style scoped>
.dialogtreeBox {
  margin-top: 10px;
  height: 300px;
  overflow-y: auto;
}
</style>
